<template>
  <div>
    <section v-if="step == 'korak-1'">
      <v-step-one
        :old="old"
        :routes="routes"
        :validation-errors="validationErrors"
        :step-data="stepData"
      ></v-step-one>
    </section>
    <section v-if="step == 'korak-2'">
      <v-step-two
        :old="old"
        :routes="routes"
        :validation-errors="validationErrors"
        :step-data="stepData"
      ></v-step-two>
    </section>
    <section v-if="step == 'korak-3'">
      <v-step-three
        :old="old"
        :routes="routes"
        :validation-errors="validationErrors"
        :step-data="stepData"
      ></v-step-three>
    </section>
    <section v-if="step == 'korak-4'">
      <v-step-four
        :old="old"
        :routes="routes"
        :validation-errors="validationErrors"
        :step-data="stepData"
      ></v-step-four>
    </section>
    <section v-if="step == 'korak-5'">
      <v-step-five
        :old="old"
        :routes="routes"
        :validation-errors="validationErrors"
        :step-data="stepData"
      ></v-step-five>
    </section>
    <section v-if="step == 'zacetek'">
      <v-start-step-simple
        :old="old"
        :routes="routes"
        :validation-errors="validationErrors"
        :step-data="stepData"
      ></v-start-step-simple>
    </section>
    <section v-if="step == 'izberi-posrednika'">
      <v-broker
        :old="old"
        :routes="routes"
        :validation-errors="validationErrors"
        :step-data="stepData"
      ></v-broker>
    </section>
    <section v-if="step == 'naslov-nepremicnine'">
      <v-select-address
        :old="old"
        :routes="routes"
        :validation-errors="validationErrors"
        :step-data="stepData"
      ></v-select-address>
    </section>
    <section v-if="step == 'vrsta-nepremicnine'">
      <v-estate-type
        :old="old"
        :routes="routes"
        :validation-errors="validationErrors"
        :step-data="stepData"
      ></v-estate-type>
    </section>
    <section v-if="step == 'velikost-cena'">
      <v-size-floor-price
        :old="old"
        :routes="routes"
        :validation-errors="validationErrors"
        :step-data="stepData"
      ></v-size-floor-price>
    </section>
    <section v-if="step == 'status-nepremicnine'">
      <v-construction-status
        :old="old"
        :routes="routes"
        :validation-errors="validationErrors"
        :step-data="stepData"
      ></v-construction-status>
    </section>
    <section v-if="step == 'podatki-parcele'">
      <v-plot-info
        :old="old"
        :routes="routes"
        :validation-errors="validationErrors"
        :step-data="stepData"
      ></v-plot-info>
    </section>
    <section v-if="step == 'obnova-dodatni-podatki'">
      <v-renovation-extra-data
        :old="old"
        :routes="routes"
        :validation-errors="validationErrors"
        :step-data="stepData"
      ></v-renovation-extra-data>
    </section>
    <section v-if="step == 'ogrevanje'">
      <v-heating
        :old="old"
        :routes="routes"
        :validation-errors="validationErrors"
        :step-data="stepData"
      ></v-heating>
    </section>
    <section v-if="step == 'opis-oglasa'">
      <v-ad-info
        :old="old"
        :routes="routes"
        :validation-errors="validationErrors"
        :step-data="stepData"
      ></v-ad-info>
    </section>
    <section v-if="step == 'fotografije'">
      <v-ad-pictures
        :old="old"
        :routes="routes"
        :validation-errors="validationErrors"
        :step-data="stepData"
      ></v-ad-pictures>
    </section>
    <section v-if="step == 'fotografije-dokumentacije'">
      <v-documentation-pictures
        :old="old"
        :routes="routes"
        :validation-errors="validationErrors"
        :step-data="stepData"
      ></v-documentation-pictures>
    </section>
    <section v-if="step == 'osebni-podatki'">
      <v-personal-data
        :old="old"
        :routes="routes"
        :validation-errors="validationErrors"
        :step-data="stepData"
      ></v-personal-data>
    </section>
    <section v-if="step == 'placilo'">
      <v-payment
        :old="old"
        :routes="routes"
        :validation-errors="validationErrors"
        :step-data="stepData"
      ></v-payment>
    </section>
  </div>
</template>

<script>
import StartStep from './Steps/01StartStep.vue';
import SelectBroker from './Steps/02Broker.vue';
import SelectAddress from './Steps/03Address.vue';
import EstateType from './Steps/04EstateType.vue';
import SizeFloorPriceData from './Steps/05SizeFloorPriceData.vue';
import ConstructionStatus from './Steps/06ConstructionStatus.vue';
import RenovationExtraData from './Steps/07RenovationExtraData.vue';
import PlotInfo from './Steps/07_2PlotInfo.vue'
import Heating from './Steps/08Heating.vue';
import AdInfo from './Steps/09AdInfo.vue';
import AdPictures from './Steps/10AdPhotos.vue';
import DocumentationPictures from './Steps/11DocumentationPictures.vue';
import PersonalData from './Steps/12PersonalData.vue';
import Payment from './Steps/14Payment.vue';

import StepOne from './Steps/01StepOne.vue';
import StepTwo from './Steps/02StepTwo.vue';
import StepThree from './Steps/03StepThree.vue';
import StepFour from './Steps/04StepFour.vue';
import StepFive from './Steps/05StepFive.vue';

export default {
  components: {
    "v-start-step-simple": StartStep,
    "v-broker": SelectBroker,
    "v-select-address": SelectAddress,
    "v-estate-type": EstateType,
    "v-size-floor-price": SizeFloorPriceData,
    'v-construction-status': ConstructionStatus,
    'v-renovation-extra-data': RenovationExtraData,
    'v-plot-info': PlotInfo,
    'v-heating': Heating,
    'v-ad-info': AdInfo,
    'v-ad-pictures': AdPictures,
    'v-documentation-pictures': DocumentationPictures,
    'v-personal-data': PersonalData,
    'v-payment': Payment,
    'v-step-one': StepOne,
    'v-step-two': StepTwo,
    'v-step-three': StepThree,
    'v-step-four': StepFour,
    'v-step-five': StepFive
  },
  props: {
    old: {
      type: Object,
      required: false,
      default: {},
    },
    step: {
      type: String,
      required: true,
    },
    routes: {
      type: Object,
      required: true,
    },
    validationErrors: {
      type: Object,
      required: true,
      default: {},
    },
    stepData: {
      type: Object,
      required: true,
      default: {},
    },
  },
  data() {
    return {
    };
  },
  methods: {
  },
  mounted() {
    //console.log(this.validationErrors);
    //console.log(this.stepData)
    //console.log(this.old);
  }
};
</script>
